
// export const API_BASE_URL = 'http://localhost:8000/api';
// export const MEDIA_BASE_URL = 'http://localhost:8000';

// Production API
// export const API_BASE_URL = 'https://api.soliatravel.com/api';
// export const MEDIA_BASE_URL = 'https://api.soliatravel.com';

export const API_BASE_URL = 'https://apiaws.soliatravel.com/api';
export const MEDIA_BASE_URL = 'https://apiaws.soliatravel.com';

// API endpoints
export const ENDPOINTS = {
  // Auth
  LOGIN: '/users/login/',
  REGISTER: '/users/register/',
  PROFILE: '/users/profile/',

  // Offers
  OFFERS: '/offers/',
  OFFER_DETAIL: (id) => `/offers/${id}/`,

  // Destinations
  DESTINATIONS: '/destinations/',
  DESTINATION_DETAIL: (id) => `/destinations/${id}/`,

  // Packages
  PACKAGES: '/packages/',
  PACKAGE_DETAIL: (id) => `/packages/${id}/`,

  // Excursions
  EXCURSIONS: '/excursions/',
  EXCURSION_DETAIL: (id) => `/excursions/${id}/`,

  // Bookings
  BOOKINGS: '/bookings/',
  BOOKING_DETAIL: (id) => `/bookings/${id}/`,

  // Users
  USERS: '/users/',
  USER_DETAIL: (id) => `/users/${id}/`,

  // Blog
  BLOG_POSTS: '/blog/',
  BLOG_POST_DETAIL: (slug) => `/blog/${slug}/`,

  // Hotels
  HOTELS: '/hotels/',
  HOTEL_DETAIL: (slug) => `/hotels/${slug}/`,

  // Settings
  SETTINGS: '/settings/',
  SETTING_DETAIL: (key) => `/settings/${key}/`,

  // Stats
  DASHBOARD_STATS: '/stats/dashboard/',
};

// Request headers
export const getAuthHeader = () => {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Response status codes
export const STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};
